import { Stack, Typography, useTheme } from "@mui/material";
import type { WorkbookFilter, WorkbookReportParameter } from "../../../../../../api/types/workbookRuns.types";
import { toLabel } from "../../../../dashboard/utils/withValue";
import { getValidatedDateString } from "../../../../reporting/utils/dateUtils";
import {
  getDateFromWorkbookFilter,
  getDateToWorkbookFilter,
  getTextWorkbookFilter,
} from "@entrilia/shared/components/reporting/workbook/workbookFiltersHelper";
import ConditionBlockValueItem from "./ConditionBlockValueItem";

interface Props {
  filter: WorkbookReportParameter;
  reportId: string;
  workbookFilters: WorkbookFilter[];
}
const formatParamValues = (filter: WorkbookReportParameter) => {
  return filter.text || filter.values.map((v) => toLabel(v)).join(", ");
};

const ConditionBlockValue = ({ filter, reportId, workbookFilters }: Props) => {
  const theme = useTheme();

  const color = theme.palette.text.primary;

  if (filter.type === "Table") {
    return (
      <ConditionBlockValueItem
        value={formatParamValues(filter)}
        workbookFilter={getTextWorkbookFilter(workbookFilters, reportId, filter.id)}
        color={color}
      />
    );
  }

  if (filter.type === "Date") {
    return (
      <ConditionBlockValueItem
        value={getValidatedDateString(filter.values[0], undefined)}
        workbookFilter={getDateFromWorkbookFilter(workbookFilters, reportId, filter.id)}
        color={color}
      />
    );
  }

  if (filter.type === "Daterange") {
    return (
      <Stack sx={{ minWidth: 0 }}>
        <ConditionBlockValueItem
          value={getValidatedDateString(filter.values[0], undefined)}
          workbookFilter={getDateFromWorkbookFilter(workbookFilters, reportId, filter.id)}
          color={color}
        />
        <ConditionBlockValueItem
          value={getValidatedDateString(filter.values[1], undefined)}
          workbookFilter={getDateToWorkbookFilter(workbookFilters, reportId, filter.id)}
          color={color}
        />
      </Stack>
    );
  }

  return (
    <Typography variant="caption" sx={{ color: color }}>
      {formatParamValues(filter)}
    </Typography>
  );
};

export default ConditionBlockValue;
